module.exports = __webpack_public_path__ + "media/images/application/schema/logo-c4f04d4f58384fb457267927d08ea63b.png";